import React, { useState } from 'react'
import { Switch, Headings, Texts, TOAST } from "retro";

function TwoFactorAuthentication() {
    const [checked, setChecked] = useState(false)

    const handleToggle =()=>{
        setChecked(!checked)
        TOAST.success(!checked ? 'Two Factor Authentication enabled' : 'Two Factor Authentication disabled')
    }
	return (
		<div>
			<h1>Two Factor Authentication</h1>
            <div
          key="2fa"
          className="retro-card"
          style={{
            flex: "1 1 calc(33.333% - 16px)", // 3 per row with gap
            minWidth: 220, // fallback for very small screens
            position: "relative",
          }}
        >
          <div
            style={{
              zIndex: 2,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Switch
              state={checked}
              onChange={handleToggle}
              size="large"
            />
          </div>

          <div
            style={{
              opacity: checked ? 1 : 0.37,
            }}
            className="relative"
          >
            <Headings.Regular margin="mt4">Two Factor Authentication</Headings.Regular>
            <Texts.Small style={{ maxLines: 2 }} className="mt1">
                Enable or disable Two Factor Authentication for BIN Management
            </Texts.Small>
          </div>
        </div>
		</div>
	)
}

export default TwoFactorAuthentication